import React, { useState } from 'react';
import { db } from "../utils/firebase";
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const contestants = [
    { id: 1, company: "Nguzo Babies", name: "Ashley Jefferson", image: "/assets/imgs/grads/Ashley-Jefferson.png" },
    { id: 2, company: "Blvck Spades", name: "E. Mackey", image: "/assets/imgs/grads/E-Mackey.png" },
    { id: 3, company: "Kindred Paper", name: "Savannah Stephens", image: "/assets/imgs/grads/Savannah-Stephens.png" },
    { id: 4, company: "Lotus Flower Om", name: "Sympony Lyrisct", image: "/assets/imgs/grads/Lotus-Flower-Om.png" },
    { id: 5, company: "Sugar Rae's Shea", name: "Raven Wortham", image: "/assets/imgs/grads/raven-2.png" },
    { id: 6, company: "Kroonz Wear", name: "RekaRek", image: "/assets/imgs/grads/RekaReek.png" },
    { id: 7, company: "Regal Love Uniforms", name: "Renande Pierre-Louis", image: "/assets/imgs/grads/Renande-Pierre-Louis.png" },
    { id: 8, company: "Blendz Apparel Inc.", name: "Jamia Ramsey", image: "/assets/imgs/grads/Jamia-Ramsey-Founder.png" },
    { id: 9, company: "J. Kiere Jewelry", name: "Jaya Johnson", image: "/assets/imgs/grads/J-Kiere-Jewelry.png" },
    { id: 10, company: "My Networking Apparel", name: "Natasha Hall", image: "/assets/imgs/grads/Natasha-Hall.png" },
    { id: 11, company: "Plant Lady Juice Co.", name: "Jennifer and Akilah", image: "/assets/imgs/grads/Jennifer-and-Akilah.png" },
    { id: 12, company: "Try Deas and Other Treats", name: "Justin Jenkins", image: "/assets/imgs/grads/Justin-Jenkins.png" },
    { id: 13, company: "Metric Mate", name: "M-T Strickland", image: "/assets/imgs/grads/M-T-Strickland.png" },
    { id: 14, company: "G Ann’s Cold Pressed", name: "Tiffany Ellis", image: "/assets/imgs/grads/Tiffany-Ellis.png" }
];


const Graduation = () => {
  const [email, setEmail] = useState('');
  const [showModal, setShowModal] = useState(true);
  const [emailError, setEmailError] = useState('');

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    console.log("validation");
    // This line checks if the provided email matches the regular expression for a valid email format
    return re.test(email);
  };

  const handleEmailSubmit = () => {
    if (validateEmail(email)) {
      setEmailError('');
      setShowModal(false);
    } else {
      setEmailError('Please enter a valid email address.');
    }
  };

  

  const handleVote = async (contestantId) => {
    if (!email) {
      setShowModal(true);
      return;
    }

    const contestantCompany = contestants.find(contestant => contestant.id === contestantId).company;

    try {
      await addDoc(collection(db, 'graduationVotes'), {
        email,
        contestantId,
        contestantCompany,
        timestamp: serverTimestamp(),
      });
      // TODO: Add a thank you page 
      window.location.href = '/';
      alert('Vote submitted successfully!');
    } catch (error) {
      console.error('Error submitting vote: ', error);
    }
  };
  // TODO: Center the modal in the middle of the page 
  // TODO: make website url open in new window 
  return (
    <div className="container">
      <div className="row">
        {showModal ? (
          <div className="modal modal-fullscreen" tabIndex="-1" role="dialog">
            <div className="modal-dialog " role="document" style={{ margin: 'auto' }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title m-auto">Please Enter Your Email to Vote</h5>
                </div>
                <div className="modal-body m-auto">
                  <input
                    type="email"
                    className='gradEmail text-center'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email Address"
                  />
                  {emailError && <div className="error error-message">{emailError}</div>}
                </div>
                <div className="modal-footer m-auto">
                  <button type="button" className="btn btn-primary" onClick={handleEmailSubmit}>Submit</button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
          {contestants.map((contestant) => (
            <div className="col-4 d-flex flex-column align-items-center mb-4 add-space" key={contestant.id}>
              <img
                alt={contestant.name}
                height="100"
                src={contestant.image}
                className="img-fluid"
              />
              <span className="gradName">{contestant.name}</span>
              <span className="gradCompany">{contestant.company}</span>
              <button className="btn btn-outline-primary btn-primary" onClick={() => handleVote(contestant.id)}>Vote</button>
            </div>
          ))}
        </>
        )}
      </div>
    </div>
  );
};
  
  export default Graduation;


